import axios from 'axios'

const parcelServices = {
  getParcels: ({ storeId, params }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/parcels`, {
      params,
      paramsSerializer: { indexes: null },
    })
  },
  getParcel: ({ storeId, parcelId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/parcels/${parcelId}`)
  },
  editParcel: ({ storeId, parcelId, payload }) => {
    return axios.patch(`${import.meta.env.VITE_HOST}/stores/${storeId}/parcels/${parcelId}`, payload)
  },
  markParcelAlertAsRead: ({ storeId, parcelId }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/parcels/${parcelId}/alerts/mark-as-read`)
  },
  uploadParcelImage: ({ storeId, resourceId, formData }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/parcels/${resourceId}/image`, formData)
  },
  sendParcelComment: ({ storeId, resourceId, text, imageIds, mentions }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/parcels/${resourceId}/comment`, {
      text,
      image_ids: imageIds,
      mentions,
    })
  },
  prepareParcel: ({ storeId, relatedId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/${relatedId}/prepare`, payload)
  },
  prepareParcels: ({ storeId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/prepare`, payload)
  },
  splitParcel: ({ storeId, relatedId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/${relatedId}/split`, payload)
  },
  resetParcel: ({ storeId, relatedId }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/${relatedId}/reset`)
  },
  cancelParcel: ({ storeId, relatedId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/${relatedId}/cancel`, payload)
  },
  getCancellableDetail: ({ storeId, relatedId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/${relatedId}/order-is-cancellable`)
  },
  generateLabel: ({ storeId, relatedId }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/${relatedId}/generate-label`)
  },
  amendParcelItems: ({ storeId, relatedId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/${relatedId}/amend-items`, payload)
  },
  getItemsCustomsInfo: ({ storeId, relatedId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/${relatedId}/items-customs-info`)
  },
  editItemsCustomsInfo: ({ storeId, relatedId, payload }) => {
    return axios.put(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/${relatedId}/items-customs-info`,
      payload
    )
  },
  sendParcelEmail: ({ storeId, relatedId, payload, destination }) => {
    return axios.post(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/${relatedId}/contact-${destination}`,
      payload
    )
  },
  generateAiEmail: ({ storeId, relatedId, payload }, config) => {
    return axios.post(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/${relatedId}/ai-generate-email`,
      payload,
      {
        signal: config?.signal,
      }
    )
  },
  getParcelNotificationPreview: ({ storeId, relatedId, notificationId }) => {
    return axios.get(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/${relatedId}/notifications/${notificationId}/preview`
    )
  },
  resendParcelNotification: ({ storeId, relatedId, notificationId }) => {
    return axios.post(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/${relatedId}/notifications/${notificationId}/resend`
    )
  },
  getCarriersByParcelStatus: ({ storeId, status, locationId }) => {
    const locationParam = locationId ? `&location_id=${locationId}` : ''

    return axios.get(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/by-carrier?status=${status}${locationParam}`
    )
  },
  schedulePickups: ({ storeId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/pickups/schedule`, payload)
  },
  openClaim: ({ storeId, resourceId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/parcels/${resourceId}/request-claim`, payload)
  },
  exportResults: ({ format, email, storeId, filters }) => {
    return axios.post(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/parcels/export`,
      {
        format,
        email,
      },
      { params: filters, paramsSerializer: { indexes: null } }
    )
  },
  generatePackingList: ({ storeId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/packing-list`, payload)
  },
  generatePickingList: ({ storeId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipments/picking-list`, payload)
  },
}

export default parcelServices
